var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 10C25.5 10.3978 25.342 10.7794 25.0607 11.0607C24.7794 11.342 24.3978 11.5 24 11.5H2C1.60218 11.5 1.22064 11.342 0.93934 11.0607C0.658035 10.7794 0.5 10.3978 0.5 10C0.5 9.60218 0.658035 9.22064 0.93934 8.93934C1.22064 8.65804 1.60218 8.5 2 8.5H24C24.3978 8.5 24.7794 8.65804 25.0607 8.93934C25.342 9.22064 25.5 9.60218 25.5 10ZM2 3.5H24C24.3978 3.5 24.7794 3.34196 25.0607 3.06066C25.342 2.77936 25.5 2.39782 25.5 2C25.5 1.60218 25.342 1.22064 25.0607 0.93934C24.7794 0.658035 24.3978 0.5 24 0.5H2C1.60218 0.5 1.22064 0.658035 0.93934 0.93934C0.658035 1.22064 0.5 1.60218 0.5 2C0.5 2.39782 0.658035 2.77936 0.93934 3.06066C1.22064 3.34196 1.60218 3.5 2 3.5ZM24 16.5H2C1.60218 16.5 1.22064 16.658 0.93934 16.9393C0.658035 17.2206 0.5 17.6022 0.5 18C0.5 18.3978 0.658035 18.7794 0.93934 19.0607C1.22064 19.342 1.60218 19.5 2 19.5H24C24.3978 19.5 24.7794 19.342 25.0607 19.0607C25.342 18.7794 25.5 18.3978 25.5 18C25.5 17.6022 25.342 17.2206 25.0607 16.9393C24.7794 16.658 24.3978 16.5 24 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.6b4a93f9f658c23cd0505729b700e3aa.svg";
export { ForwardRef as ReactComponent };